import { useQuery } from "react-query";
import { getSearchForDownload } from "../../../../actions/CarrierAgreementMgmt/Vendor";

const useSearchForDownload = (filteredValue) => {
  return useQuery(
    ["GetSearchForDownload", filteredValue],
    () => getSearchForDownload(filteredValue),
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useSearchForDownload;
